import * as types from './mutation-types'

export default {

  [types.LOAD_DASHBOARD_STATS](state, data) {
    state.dashboardStats = {...data}
  },
  [types.LOAD_STATISTICS](state, data) {
    state.statistics = data
  },
  [types.LOAD_SALES_STATISTICS](state, data) {
    state.saleStatistics = data
  },
  [types.LOAD_WIDGETS](state, data) {
    state.widgets = data
  },
  [types.LOAD_USER_WIDGETS](state, data) {
    state.addedWidgets = data
  },
  
}

